import React from 'react';
import './sec4.css'
import Titles from '../components/common/titles';
import FAQss from '../components/common/faq';


const Sec4 = () => {
    return ( 
        <section className='sec4 '>
                <article className='container-sec4'>
                    <Titles title='FAQ' stylee='title-left'/>
                    <article className='faqslist'>
                        <FAQss title='How can I get a quote for my project?' 
                     parag='  You can request a quote by filling out our contact form or 
                     speaking directly with one of our consultants.'/>

                        <FAQss title='What types of projects does Domus specialize in?' 
                     parag=' Domus specializes in residential,
                      commercial, and mixed-use real estate projects.'/>

                        <FAQss title='Can Domus help with the design process?' 
                     parag=' Yes, Domus provides professional support and guidance 
                     throughout the entire design process.'/>


                        <FAQss title='What is the process to book a villa?' 
                     parag=' To book a villa, simply contact our sales team, choose your preferred unit,
                      and complete the reservation and payment process.'/>

                        <FAQss title='Do you offer financing options?' 
                     parag=' Yes, we offer flexible financing options
                      in partnership with trusted banks to make your purchase easier and more convenient.'/>


                    </article>
                </article>
        </section>
     );
}
 
export default Sec4;